import dicomParser from 'dicom-parser';

const DICOM_EXTENSIONS = new Set(['.dcm', '.dicom', '']);

function isDicomFile(file) {
    const ext = file.name.lastIndexOf('.') !== -1
        ? file.name.slice(file.name.lastIndexOf('.')).toLowerCase()
        : '';
    if (DICOM_EXTENSIONS.has(ext)) return true;
    if (file.type === 'application/dicom') return true;
    return false;
}

function parseDate(dateStr) {
    if (!dateStr || dateStr.length < 8) return null;
    const year = dateStr.substring(0, 4);
    const month = dateStr.substring(4, 6);
    const day = dateStr.substring(6, 8);
    return new Date(`${year}-${month}-${day}T00:00:00`);
}

function formatName(nameStr) {
    if (!nameStr) return null;
    return nameStr
        .replace(/\^/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}

async function parseDicomMetadata(file) {
    const HEADER_SIZE = Math.min(64 * 1024, file.size);
    const slice = file.slice(0, HEADER_SIZE);
    const arrayBuffer = await slice.arrayBuffer();
    const byteArray = new Uint8Array(arrayBuffer);

    const dataSet = dicomParser.parseDicom(byteArray, { untilTag: 'x7fe00010' });

    return {
        patientName: formatName(dataSet.string('x00100010')),
        patientDob: parseDate(dataSet.string('x00100030')),
        patientSex: dataSet.string('x00100040') || null,
        studyDate: parseDate(dataSet.string('x00080020')),
        referringPhysician: formatName(dataSet.string('x00080090')),
        studyDescription: dataSet.string('x00081030') || null,
        patientId: dataSet.string('x00100020') || null,
    };
}

export async function extractDicomMetadata(files) {
    const dicomFiles = files.filter(isDicomFile);
    if (dicomFiles.length === 0) return null;

    for (const file of dicomFiles.slice(0, 3)) {
        try {
            const metadata = await parseDicomMetadata(file);
            if (metadata.patientName || metadata.studyDate) {
                return metadata;
            }
        } catch (_) {
            continue;
        }
    }

    return null;
}
